module.exports = __webpack_public_path__ + "img/delete-bin.39eef1ee.svg";